import PropTypes from 'prop-types'
import { memo, useMemo } from 'react'
import classNames from 'lib/util/classNames'
import Item from './Item/Item'
import styles from './NavList.module.scss'

/**
 * The `NavList`
 *
 * @param {object} props - the component props
 * @returns {React.ReactElement} the element
 */
function NavListComponent (props) {
  const { children, className, type } = props
  const classNameOutput = useMemo(
    () => classNames([className, styles.nav, styles[`type-${type}`]]),
    [className, type]
  )

  return (
    <nav className={classNameOutput}>
      <ul>{children}</ul>
    </nav>
  )
}

/** @type {object} */
NavListComponent.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  type: PropTypes.string
}

/** @type {object} */
NavListComponent.defaultProps = {
  children: null,
  className: '',
  type: 'a'
}

// Memoize
const NavList = memo(NavListComponent)

// Bind the types
NavList.Item = Item

// Export
export default NavList
